import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import type { Place } from 'tripPlanner/types/common'

const LocationWrapper = styled.div`
  display: flex;
  width: 100%;
`

const Location = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

type Props = {
  startPlace: Place
  endPlace?: Place
}

function StartAndEndLocation({ startPlace, endPlace }: Props) {
  const intl = useIntl()

  return (
    <LocationWrapper>
      <Location>
        <BodyText variant="medium" weight="bold">
          {intl.formatMessage({
            id: 'jipi6I+to/',
            defaultMessage: 'Pick up location',
            description: 'Label for the pick up location in trip item summary',
          })}
        </BodyText>
        <BodyText variant="large">{startPlace.name}</BodyText>
      </Location>
      {endPlace && (
        <Location>
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: 'PkzrFVIQp4',
              defaultMessage: 'Drop off location',
              description: 'Label for the drop off location in trip item summary',
            })}
          </BodyText>
          <BodyText variant="large">{endPlace.name}</BodyText>
        </Location>
      )}
    </LocationWrapper>
  )
}

export default StartAndEndLocation
